import {
  Box,
  BoxProps,
  Divider,
  Heading,
  Image,
  Link,
  Stack,
  Text,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { IRequestDemoView } from '@/imports/ui/amplitude/types';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { RequestDemoButton } from '@/imports/ui/components/RequestDemoButton';
import { getExternalUrl } from '@/utilities/getExternalUrl';

export const EventPromotionBox: React.FC<
  {
    image?: string;
    organizationName: string;
    organizationId: string;
    title: string;
    body: string;
    callToAction: string;
    url: string;
    registerInterestTitle: string | null;
    origin: {
      conferenceBoothId?: string;
      sponsoredEventId?: string;
      sponsoredConferenceSessionId?: string;
      hostedEventId?: string;
      sponsorPage?: boolean;
    };
    analytics: {
      view: IRequestDemoView;
      tier: string;
    };
  } & BoxProps
> = ({
  image,
  organizationName,
  organizationId,
  title,
  body,
  callToAction,
  url,
  registerInterestTitle,
  origin,
  analytics,
  ...boxProps
}) => {
  const fullUrl = getExternalUrl(url);

  return (
    <Box w="280px" textAlign="center" {...boxProps}>
      <Stack spacing="4">
        <NextLink href={`/companies/${organizationId}`}>
          <Stack spacing="4" cursor="pointer">
            <Image
              alt={`Sponsor promotion for ${organizationName}`}
              src={image}
              fallback={<ImageFallback aspectRatio="1" borderRadius="base" />}
              mx="auto"
              borderRadius="base"
            />

            <Heading size="md">{organizationName}</Heading>
          </Stack>
        </NextLink>

        <Divider my="6" />

        <Stack spacing="6">
          <Stack spacing="1">
            <Heading size="sm">{title}</Heading>
            <Text color="gray.600">{body}</Text>
          </Stack>
          <RequestDemoButton
            options={{
              organizationId,
              origin,
              registerInterestTitle,
              analytics,
            }}
            w="full"
          />
        </Stack>

        <Link href={fullUrl} isExternal>
          {callToAction}
        </Link>
      </Stack>
    </Box>
  );
};
